(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ErrorController', ErrorController);

    ErrorController.$inject = ['$window', 'NO_PROJECT_URL', '$localStorage'];

    function ErrorController($window, NO_PROJECT_URL, $localStorage) {
        var vm = this;

        if ($localStorage.project === undefined){
            $window.location.assign(NO_PROJECT_URL);
        }

        return vm;
    }
})();
